import { ThemisAnalyticsError } from './themis-analytics.error';
export class ThemisAnalyticsOptionsValidationError extends ThemisAnalyticsError {
    constructor(message) {
        super(message);
        this.name = 'ThemisAnalyticsOptionsValidationError';
    }
}
//# sourceMappingURL=themis-analytics-options-validation.error.js.map